module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_m_albino.e4eb4c10.png";